import React from "react";
import img_404 from "../../assets/img_404.png";
import NavBar from "../../Nav Bar/NavBar";
import ColoredLogo from "../../assets/ColoredLogo.svg";

const ErrorPage = () => {
  return (
    <>
      <NavBar linkColor="#000" logo={ColoredLogo} bg="#fff" />
      <div className="container d-flex justify-content-center align-items-center mt-5 h-100">
        <div className="m-5">
          <img className="w-100 mt-5 mb-5" src={img_404} alt="404" />
        </div>
      </div>
    </>
  );
};

export default ErrorPage;
